import { NgModule, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader, TranslatePipe, TranslateService } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslatetionModule.HttpLoaderFactory,
        deps: [HttpClient]

      }
    })
  ],
  exports: [
    TranslateModule

  ]
})
export class TranslatetionModule {

  public static HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, location.origin + '/style library/Adahi/adahi-app/assets/common/', '.json');
  }

}




